<template lang="pug">
		tr
			//- div
			//- 	input.form-control.form-control-sm(:disabled="true", :value="value.LineaID")
			td.p-0.producto(style="")
				.input-group
					.input-group-prepend
						button.btn.btn-sm(:class="(value.Tipo !== 'Articulo') ? 'btn-primary': ''", @click="setTipo('Otros')", title="Otros")
							span.fa.fa-shopping-basket
						button.btn.btn-sm(:class="(value.Tipo === 'Articulo') ? 'btn-primary': ''", @click="setTipo('Articulo')", title="Artículo")
							span.fa.fa-search
					input.form-control.form-control-sm(
						v-if="value.Tipo === 'Otros' || value.ArticuloID"
						placeholder="Concepto"
						v-model="value.Concepto"
						:disabled="value.ArticuloID"
					)
					input-query(
						v-if="value.Tipo === 'Articulo' && !value.ArticuloID"
						input-class="form-control form-control-sm"
						url="/mis-contratos/php/api/busca-articulos.php"
						:realtime="true"
						@selected="seleccionaTarifa($event)"
					)
					.input-group-append(v-if="value.ArticuloID")
						button.btn.btn-sm.btn-danger(@click="quitarTarifa")
							span.fa.fa-trash
					
					.input-group-append(v-if="value.Tipo === 'Otros'")
						select.form-control.form-control-sm(v-model="value.CatalogoID")
							option(:value="false") Selecciona soporte
							option(:value="null") Sin soporte asignado
							option(v-for="destino in listadoDestinos", :key="destino.CatalogoID", :value="destino.CatalogoID") {{destino.Nombre}}
			td.p-0
				input.form-control.form-control-sm(
					v-if="value.Tipo === 'Articulo'"
					:disabled="true"
					:value="value.ImporteUnitario"
				)
				input.form-control.form-control-sm(
					:disabled="!seleccionValida",
					v-if="value.Tipo === 'Otros'",
					v-model.number="value.ImporteUnitario"
					@keyup="calculaImporte"
				)
			td.p-0
				input.form-control.form-control-sm(
					:disabled="!value.ArticuloUnitario",
					v-model.number="value.Unidades"
					@keyup="calculaImporte"
				)
			td.p-0
				input.form-control.form-control-sm(
					:disabled="!seleccionValida",
					v-model.number="value.Cantidad"
					@keyup="calculaImporte"
				)
			td.p-0
				input.form-control.form-control-sm(
					v-model.number="descuento"
					@keyup="calculaImporte"
				)
			td.p-0
				select.form-control.form-control-sm(
					v-model.number="value.ImpuestosID"
					@change="cambiaImpuestos"
				)
					option(:value="null") -
					option(v-for="imp of listadoImpuestos", :key="imp.ID_impuesto", :value="imp.ID_impuesto") {{imp.nombre}} - {{imp.valor}} %
			td.p-0
				input.form-control.form-control-sm(
					v-model.number="value.ImporteBruto"
					disabled
				)
			td.p-0
				input.form-control.form-control-sm(
					v-model.number="value.ImporteNeto"
					@keyup="calculaDescuento"
				)
			td.p-0
				input.form-control.form-control-sm(
					v-model.number="value.ImporteTotal"
					:disabled="true"
				)
			td.p-0.text-right(style="max-width:60px;text-align:center;")
				button.btn.btn-sm.btn-danger(@click="$emit('eliminar', value)")
					span.fa.fa-trash
</template>

<script>
import axios from 'axios'
import API from './../../services/api'
export default {
	props: ['value', 'idx', 'dtoCadValor', 'dtoComercial'],
	data () {
		return {
			listadoDestinos: [],
			listadoImpuestos: [],
			descuento: 0
		}
	},
	watch: {
		dtoCadValor (newVal) {
			this.value.DescuentoCadenaValor = newVal
			this.calculaImporte()
		},
		dtoComercial (newVal) {
			this.value.DescuentoComercial = newVal
			this.calculaImporte()
		}
	},
	created () {
		if (this.value.Descuento) {
			this.descuento = this.value.Descuento + 0
		}
		this.getSoportes()
		this.calculaImporte()
		API.getImpuestos()
			.then(res => {
				this.listadoImpuestos = res.data.impuestos

				if (this.value.Impuestos === null) {
					for (let i = 0; i < this.listadoImpuestos.length; i++) {
						if (this.listadoImpuestos[i].predeterminado) {
							this.value.Impuestos = this.listadoImpuestos[i].valor
							this.value.ImpuestosID = this.listadoImpuestos[i].ID_impuesto
							this.value.ImpuestosNombre = this.listadoImpuestos[i].nombre
						}
					}
				}
			})
			.catch(e => {
				this.$store.commit('toast/danger', {
					titulo: 'Error',
					mensaje: e.response.data.error
				})
			})
	},
	computed: {
		seleccionValida () {
			if (this.value.Tipo === 'Articulo') {
				return (this.value.ArticuloID)
			} else {
				return (this.value.Concepto)
			}
		}
	},
	methods: {
		calculaDescuento () {
			const bruto = this.value.ImporteUnitario * this.value.Unidades * this.value.Cantidad
			const total = this.value.ImporteNeto
			const descuento = 100 - (total * 100 / bruto)
			this.descuento = this.round(descuento, 2)

			// this.calculaImporte()
			this.calculaTotal()
		},
		resetImportes () {
			this.value.CatalogoID = null
			this.value.ArticuloID = null
			this.value.Concepto = null
			this.value.ImporteUnitario = null
			this.value.Unidades = null
			this.value.Cantidad = null
			this.value.Descuento = null
			this.value.ImpuestosID = 1
			this.value.Impuestos = 21
			this.value.ImpuestosNombre = 'IVA'
			this.value.ImporteBruto = null
			this.value.ImporteNeto = null
			this.value.ImpoteTotal = null
			this.value.Tipo = 'Articulo'
		},
		setTipo (tipo) {
			this.value.Tipo = tipo
			this.value.ArticuloID = null
			this.value.CatalogoID = null

			if (this.value.Tipo === 'Otros') {
				this.value.ArticuloUnitario = 0
				this.value.Unidades = 1
				this.getSoportes()
			}
		},

		seleccionaTarifa (e) {
			this.value.CatalogoID = e.datos.CatalogoID
			this.value.ArticuloID = e.datos.ArticuloID
			this.value.Concepto = e.datos.CatalogoNombre + ' - ' + e.datos.Nombre
			this.value.ImporteUnitario = e.datos.Importe
			this.value.Unidades = 1
			this.value.ArticuloUnitario = (e.datos.ArticuloUnitario === 'Si')
			this.value.Cantidad = 1
			this.value.Descuento = 0
			this.value.Tipo = 'Articulo'
			this.calculaImporte()
		},

		quitarTarifa () {
			this.resetImportes()
		},

		getSoportes () {
			axios.get('/mis-contratos/php/api/get-catalogos.php')
				.then(res => {
					this.listadoDestinos = res.data.catalogos
				})
				.catch(this.$responseError)
		},

		cambiaImpuestos () {
			if (this.value.ImpuestosID === null) {
				this.value.Impuestos = null
				this.value.ImpuestosNombre = null
				this.calculaImporte()
				return
			}

			for (let i = 0; i < this.listadoImpuestos.length; i++) {
				if (this.listadoImpuestos[i].ID_impuesto === this.value.ImpuestosID) {
					this.value.Impuestos = this.listadoImpuestos[i].valor
					this.value.ImpuestosNombre = this.listadoImpuestos[i].nombre
				}
			}

			this.calculaImporte()
		},

		calculaImporte () {
			this.value.ImporteBruto = this.value.ImporteUnitario * this.value.Unidades * this.value.Cantidad
			this.value.ImporteNeto = this.value.ImporteBruto + 0
			if (this.descuento) {
				this.value.ImporteNeto = this.value.ImporteNeto * (100 - this.descuento) / 100
				this.value.Descuento = 0 + this.descuento
			} else {
				this.value.Descuento = this.value.ImporteNeto * 100 / this.value.ImporteBruto
			}

			this.value.ImporteBruto = this.round(this.value.ImporteBruto, 2)
			this.value.ImporteNeto = this.round(this.value.ImporteNeto, 2)

			this.calculaTotal()

			this.$emit('input', this.value)
			this.$forceUpdate()
		},

		calculaTotal () {
			this.value.ImporteTotal = this.value.ImporteNeto + 0

			if (this.dtoCadValor) {
				this.value.ImporteTotal = this.value.ImporteTotal - (this.value.ImporteTotal * this.dtoCadValor / 100)
				this.value.ImporteTotal = this.round(this.value.ImporteTotal, 2)
			}

			if (this.dtoComercial) {
				this.value.ImporteTotal = this.value.ImporteTotal - (this.value.ImporteTotal * this.dtoComercial / 100)
				this.value.ImporteTotal = this.round(this.value.ImporteTotal, 2)
			}

			if (this.value.Impuestos) {
				this.value.ImporteTotal = this.value.ImporteTotal + (this.value.ImporteTotal * this.value.Impuestos / 100)
				this.value.ImporteTotal = this.round(this.value.ImporteTotal, 2)
			}

			this.value.Descuento = this.round(this.descuento, 2)

			this.$emit('input', this.value)
			this.$forceUpdate()
		}
	}
}
</script>

<style scoped>
.linea-contrato {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  /* align-items: stretch; */
  align-content: stretch;
  width: 100%;
}
.linea-contrato > div {
  flex-basis: 90px;
  flex-grow: 2;
  flex-shrink: 1;
  margin: 1px;
  align-self: auto;
}

.producto {
  flex-basis: 130px !important;
  flex-grow: 2 !important;
  flex-shrink: 0 !important;
  margin: 1px;
  align-self: auto;
}

input {
	border-radius: 0;
}

select {
	border-radius: 0;
}

td {
	padding: 1px !important;
	border: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/modulos/mis-contratos/vue/components/contrato/linea-contrato.vue